import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './PaymentFailed.css';

export function PaymentFailed() {
  const navigate = useNavigate();
  const [reason, setReason] = useState('');
  const [txnId, setTxnId] = useState('');

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const r = queryParams.get('reason');
    const t = queryParams.get('txnId');
    if (r) setReason(decodeURIComponent(r));
    if (t) setTxnId(decodeURIComponent(t));
  }, []);

  return (
    <div className="pf-page">
      {/* Ambient background */}
      <div className="pf-bg">
        <div className="pf-bg__orb pf-bg__orb--1" />
        <div className="pf-bg__orb pf-bg__orb--2" />
        <div className="pf-bg__grid" />
      </div>

      <div className="pf-container">
        {/* Failure hero */}
        <div className="pf-hero">
          <div className="pf-hero__ring">
            <div className="pf-hero__icon">✕</div>
          </div>
          <h1 className="pf-hero__title">Payment <span className="pf-hero__accent">Failed</span></h1>
          <p className="pf-hero__sub">
            Unfortunately your payment could not be processed. No amount has been charged.
          </p>
        </div>

        {/* Reason card */}
        <div className="pf-reason-card">
          <div className="pf-reason-card__icon">⚠️</div>
          <div className="pf-reason-card__content">
            <span className="pf-reason-card__label">Reason</span>
            <span className="pf-reason-card__value">
              {reason || 'Payment was declined or cancelled.'}
            </span>
          </div>
        </div>

        {/* Transaction ID if available */}
        {txnId && (
          <div className="pf-txn-id">
            <span className="pf-txn-id__label">Transaction Reference</span>
            <span className="pf-txn-id__value">{txnId}</span>
          </div>
        )}

        {/* Info box */}
        <div className="pf-info-box">
          <div className="pf-info-box__row">
            <span className="pf-info-box__icon">💳</span>
            <span>No amount has been deducted from your account.</span>
          </div>
          <div className="pf-info-box__row">
            <span className="pf-info-box__icon">🔄</span>
            <span>If you were charged, the amount will be refunded within 5–7 business days.</span>
          </div>
          <div className="pf-info-box__row">
            <span className="pf-info-box__icon">📧</span>
            <span>For help, contact us at <strong>support@luminarentertainment.tech</strong></span>
          </div>
        </div>

        {/* CTA */}
        <div className="pf-cta">
          <Link to="/" className="pf-cta__home">← Back to Home</Link>
          <button
            className="pf-cta__retry"
            onClick={() => navigate('/book-tickets')}
          >
            🔄 Try Again
          </button>
        </div>
      </div>
    </div>
  );
}
